import React from 'react';
import { createStyles, Flex, Stack } from '@mantine/core';
import { IconCircle } from '@tabler/icons-react';

import { Text } from '~/domains/design-system/Text';

import type { PlayerInfo } from '../../types/player';
import isPlayerInfoUpcoming from '../../utils/isPlayerInfoUpcoming';

const useStyles = createStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: theme.white,
  },
}));

type GamecenterPlayerDetailGameInfoProps = {
  playerInfo?: PlayerInfo;
};

function GamecenterPlayerDetailGameInfo({ playerInfo }: GamecenterPlayerDetailGameInfoProps) {
  const { classes, theme } = useStyles();

  if (!playerInfo) {
    return null;
  }

  if (isPlayerInfoUpcoming(playerInfo)) {
    return null;
  }

  return (
    <div className={classes.container}>
      <div>
        {playerInfo.nextPlay ? (
          <Text variant="headline-medium" color={theme.colors.gray2[6]}>
            {playerInfo.nextPlay}
          </Text>
        ) : null}

        <Flex gap={theme.other.spacing._4}>
          {playerInfo.isLive && (
            <Flex pt={theme.other.spacing._2}>
              <IconCircle size={10} color={theme.colors.green[6]} fill={theme.colors.green[6]} />
            </Flex>
          )}
          {playerInfo.play && (
            <Text variant="body-small" color={theme.colors.gray2[6]}>
              {playerInfo.play}
            </Text>
          )}
          {playerInfo.gameTime && (
            <Text variant="body-small" color={theme.colors.gray2[3]}>
              {playerInfo.play && '•'} {playerInfo.gameTime}
            </Text>
          )}
        </Flex>
      </div>
      {playerInfo.points && (
        <Stack spacing={0} align="end">
          <Text variant="headline-medium" color={theme.colors.gray2[6]}>
            {playerInfo.points.value}
          </Text>
          <Text variant="body-small" color={theme.colors.gray2[6]}>
            {playerInfo.points.label}
          </Text>
        </Stack>
      )}
    </div>
  );
}

export default GamecenterPlayerDetailGameInfo;
